export default {
  Community: {
    title: "Community",
    description: "Knowledge sharing between doctors on clinical cases",
    all_cases: "All Cases",
    my_cases: "My Cases",
    case: {
      shareLink: {
        1: "Check out the case",
        2: "on AI Opinion Platform:",
      },
    },
  },
};
